import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({

    state: {
        is_login: true, // 用户id
        token: '', // 登录token  
    },

    getters: {
        is_login: state => state.is_login,
        token: state => state.token,
    },

    mutations: {
        SET_IS_LOGIN(state, is_login) {
            state.is_login = is_login
        },
        SET_USER(state, user) {
            state.user = user
        },
        SET_TOKEN(state, token) {
            state.token = token
        },
    },

});

export default store